import React from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <Loader2 className="h-6 w-6 animate-spin text-primary" />
  </div>
);

// Requires an authenticated user (any auth method)
export const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

// Requires a paid + onboarded user (core product gate)
export const RequirePaid = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.paid) return <Navigate to="/checkout" replace />;
  if (!user.onboarding_complete) return <Navigate to="/onboarding" replace />;
  return children;
};
